import { useNavigate } from 'react-router-dom';
import { GovGrid } from '@gov-design-system-ce/react';
import { useLocale } from '@gov-nx/core/service';
import { PageCode, useRozcestnikContext } from '@gov-nx/module/page';
import { Button, LayoutGap, SectionHeader } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';
import type { SignpostContext } from '../../../../../module/page/src/rozcestnik/context.types';
import { HomepageFOServicesSection } from './HomepageFOServicesSection';
import { HomepageServiceTile } from './HomepageServiceTile';

const getSlicedServices =
	(isFO: boolean) =>
	(signpost: SignpostContext['data'][number], index: number) => {
		if (isFO) {
			// Strip the first one out, as it is in it's own section above (zacnete-s-podnikanim)
			return signpost.name && index < 10 && index > 0;
		}
		return signpost.name && index < 9;
	};

export const HomepageServicesSection = () => {
	const { data, isFO } = useRozcestnikContext();
	const { t } = useLocale(PageCode['rozcestnik']);
	const navigate = useNavigate();

	if (!data.length) {
		return null;
	}

	return (
		<>
			{isFO && <HomepageFOServicesSection />}
			<section aria-labelledby="sluby-portalu">
				<LayoutGap gap="m">
					<SectionHeader
						id="sluby-portalu"
						headline={t('nadpis.sluzby-portalu')}>
						<Button
							color="primary"
							size="s"
							type="base"
							aria-label={t('akce.wcag.zobrazit-vse-oblibene')}
							onClick={() => navigate(pageRouteResolver('sluzby'))}>
							{t('akce.zobrazit-vse')}
						</Button>
					</SectionHeader>
					<GovGrid gap="l">
						{data.filter(getSlicedServices(isFO)).map((service) => (
							<HomepageServiceTile service={service} />
						))}
					</GovGrid>
				</LayoutGap>
			</section>
		</>
	);
};
